const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  hot ({ state, commit, rootState }, params) {
    return rootState.axios.get('/quiz/v1frontend/question/hot', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
